import {useLocation} from 'react-router'
import {Navigate} from 'react-router'
import {maybe} from '@freckle/maybe'
import {
  extractQueryParams,
  parseQueryParamNumArray
} from '@freckle/educator-entities/ts/common/helpers/routers/query-params'
import {useSchools} from '@freckle/educator-entities/ts/common/hooks/use-schools'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import type {QueryParamsProps} from '@freckle/school/ts/manage-teachers/components/manage-teachers/container'
import {ManageTeachersContainer} from '@freckle/school/ts/manage-teachers/components/manage-teachers/container'
import {parseTab} from '@freckle/school/ts/manage-teachers/components/manage-teachers/utils'

type Location = ReturnType<typeof useLocation>

export default function ManageTeachersHandler() {
  const location = useLocation()
  const params = getQueryParams(location)
  const schools = useSchools()

  return (
    <WithResources
      resources={{schools}}
      render={({schools}) => <ManageTeachersContainer schools={schools} {...params} />}
      error={() => <Navigate to={Routes.noSchools()} replace />}
    />
  )
}

function getQueryParams(location: Location): QueryParamsProps {
  const paramMap = extractQueryParams(location)

  const pathSchoolIds =
    paramMap !== null && paramMap !== undefined ? paramMap.get('schoolIds') : null
  const schoolIds = maybe(
    () => null,
    pSchoolIds => parseQueryParamNumArray(pSchoolIds),
    pathSchoolIds
  )

  const position = maybe(
    () => null,
    pMap => pMap.get('position'),
    paramMap
  )
  const limit = maybe(
    () => null,
    pMap => {
      const val = pMap.get('limit')
      return val !== undefined ? parseInt(val, 10) : null
    },
    paramMap
  )
  const searchValue = maybe(
    () => null,
    pMap => pMap.get('searchValue'),
    paramMap
  )
  const activeTabPath = maybe(
    () => null,
    pMap => pMap.get('activeTab'),
    paramMap
  )
  const activeTab =
    activeTabPath !== null && activeTabPath !== undefined ? parseTab(activeTabPath) : null

  const tableParams = {position, limit, searchValue}

  return {schoolIds, activeTab, tableParams}
}
